/* unplugin-vue-components disabled */import { render } from "./HotAuthorInfo.vue?vue&type=template&id=7f696de5&scoped=true"
import script from "./HotAuthorInfo.vue?vue&type=script&lang=js"
export * from "./HotAuthorInfo.vue?vue&type=script&lang=js"

import "./HotAuthorInfo.vue?vue&type=style&index=0&id=7f696de5&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f696de5"]])

export default __exports__